<div class="add-comment-stips-list-wrapper">
    <div *ngFor="let stip of availableStips; let stipIndex = index">
        <div class="stip-option">
            <label for="stip-{{stip.stipId}}">
                <input type="checkbox"
                    name="stip-{{stip.stipId}}"
                    id="stip-{{stip.stipId}}"
                    (change)="onStipSelectedChange($event, stip)"
                    [checked]="stip.stipId === newStip.stipId">
                <h5 class="title">Stip {{stipIndex + 1}}</h5>
                <p class="text" [innerHTML]="stip.stipulation | safeHtml"></p>
            </label>
        </div>
    </div>
    <hr class="separator">
    <div class="add-comment-form">
        <div>
            <textarea name="resolution" rows="4"
                [(ngModel)]="newStip.stipulation" 
                [disabled]="!newStip ||
                            newStip.stipId === null"
                (change)="newStip.stipulation = newStip.stipulation.trim()"></textarea>
        </div>
        <div class="text-right">
            <button class="btn btn-sm btn-submit btn-secondary"
                [disabled]="processing ||
                            !newStip ||
                            newStip.stipId === null ||
                            newStip.stipulation.trim() === ''"
                (click)="onCreateStip()">
                Post Stip
                <div *ngIf="processing" class="loading-wrapper">
                    <i class="fas fa-spinner"></i>
                </div>
            </button>
        </div>
    </div>
</div>